import { Box, Card, CardHeader, Divider, Theme } from '@mui/material';
import { DateTime } from 'luxon';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ChannelsStats } from '../../../sic-lib/types/ChannelsStats';
import UnrespondedByChannelList from './UnrespondedByChannelList/UnrespondedByChannelList';

const useStyles = makeStyles()((theme: Theme) => ({
    paperContainer: {
        height: '53vh',
        display: 'flex',
        flexDirection: 'column',
    },
    timeline: {
        overflow: 'auto',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
}));

interface Props {
    channelStats: ChannelsStats[];
    setChannelDate: React.Dispatch<React.SetStateAction<DateTime>>;
    date: DateTime;
}

export default function UnrespondedByChannel({ channelStats, setChannelDate, date }: Props) {
    const { classes } = useStyles();

    return (
        <Card className={classes.paperContainer}>
            <CardHeader title="Unresponded by Channel" />
            <Divider />
            <Box className={classes.timeline}>
                <UnrespondedByChannelList channelStats={channelStats} />
            </Box>
        </Card>
    );
}
